module.exports = __webpack_public_path__ + "img/1008422-1606818568.6e3b91c2.jpg";